// extracted by mini-css-extract-plugin
export var statItem = "_fa-1";
export var statsRow = "_fa-0";